import BaseAreaChart from '@/components/BaseAreaChart'
import type { BasePriceItem } from 'api-price'
import { observer } from 'mobx-react-lite'
import { FC, useMemo } from 'react'
import { IColumnsProps } from '..'
import { ChartStyled } from './style'
import { LoadingSquareAnimate } from '@/components/BaseLoadingOverlay'

const Chart: FC<BasePriceItem & Pick<IColumnsProps, 'lineData' | 'lineLoading'>> = ({
  lineLoading,
  price,
  gate_id,
  lineData,
}) => {
  const loading = useMemo(() => {
    if (typeof lineData === 'undefined') {
      return true
    }
    return lineLoading
  }, [lineData, lineLoading])

  const chart = lineData?.[gate_id]

  if (!loading && !chart?.length) {
    return <span className="text-3 font-500 size-12">--</span>
  }

  return (
    <ChartStyled align="center" justify="center">
      {loading ? (
        <LoadingSquareAnimate />
      ) : (
        <BaseAreaChart
          baseLine={Number(chart?.[0]?.price ?? price)}
          data={chart?.map?.((item: any) => [item?.price_time, item?.price]) ?? []}
        />
      )}
    </ChartStyled>
  )
}

export default observer(Chart)
